import React, { useEffect, useRef } from 'react';

//import originalData from 'variables/data.js';
//import {logDataValues} from 'variables/utils.js';
import Chart from 'chart.js';
import { stanfordDiagramPlugin } from 'chartjs-plugin-stanford-diagram';

//logDataValues(originalData);


export default function StanfordChart({chartData=[]}){
  const chartRef = useRef(null);
  
  
  useEffect(() => {
    // if (!chartData || chartData.length === 0) {
    //   console.error('chartData is undefined or empty');
    //   return;
    // }
    const ALERT_LIMIT = 556;
    const MAX_AXIS_VALUE = 800;
    const MAX_AXIS_VALUE_X = 800; // x축의 실제 최대값
    const MAX_AXIS_VALUE_Y = 800; // y축의 최대값은 그대로 유지
    // x축 데이터 변환을 위한 설정
    const BREAK_POINT = 10; // x=60까지는 원래대로 표시
    const DISPLAY_MAX_X = 100; // 변환된 x축에서의 최대값

    // x축 데이터를 변환하여 빈 공간 생략
    // const transformedData = chartData.map((point) => {
    //   let x = parseFloat(point.x);
    //   const y = parseFloat(point.y);
    //   if (x > BREAK_POINT) {
    //     // BREAK_POINT 이후의 값은 압축하여 변환
    //     x =
    //       BREAK_POINT +
    //       ((x - BREAK_POINT) / (MAX_AXIS_VALUE_X - BREAK_POINT)) *
    //         (DISPLAY_MAX_X - BREAK_POINT);
    //   }
    //   return { x, y, epochs: point.epochs };
    // });
    function transformX(x) {
      if (x <= BREAK_POINT) {
        return x;
      } else {
        return (
          BREAK_POINT +
          ((x - BREAK_POINT) / (MAX_AXIS_VALUE_X - BREAK_POINT)) *
            (DISPLAY_MAX_X - BREAK_POINT)
        );
      }
    }

    // 데이터 변환
    const transformedData = chartData.map((point) => {
      let x = parseFloat(point.x);
      const y = parseFloat(point.y);
      x = transformX(x);
      return { x, y, epochs: point.epochs };
    });

      // async 함수를 사용할 수 없으므로, 별도의 async 함수를 선언하고 호출
      
      // const fetchData = async () => {
      
      //Base64 인코딩 없이 평문으로 수신
        // const response = await fetch('http://localhost:8001/a');
        // const LSIMdata = await response.json();        
        // const chartData = Object.values(LSIMdata).map(e => {
        //   //return {x: row[0], y: row[1], epochs: row[2]};
        //   return {x: e.x, y: e.y, epochs: e.epochs};
        // });
        // var LSIMdata='';
        // var chartData='';
        // updateResponse(LSIMdata);

        // var chartData='';
        // setChartData(chartData);
        //Base64 인코딩 수신
        // const response = await fetch('http://localhost:8001/a');
        // const base64Data = await response.text();
        // // Decode the Base64 data to a buffer
        // const buffer = Buffer.from(base64Data, 'base64');
        // // Parse the buffer to a JSON string
        // const jsonString = buffer.toString('utf-8');
        // // Parse the JSON string to an array
        // const LSIMdata = JSON.parse(jsonString);
        // const chartData = Object.values(LSIMdata).map(row => {
        //   return {x: row[0], y: row[1], epochs: row[2]};
        // });
        

    const data = {
      labels: 'Horizontal Data Set',
      datasets: [
        {
          // data: chartData,
          data: transformedData,
          pointRadius: 1.5
        },
        
      ],
    };

    const options = {
      scales: { // https://www.chartjs.org/docs/latest/axes/labelling.html#scale-title-configuration
        xAxes: [{
          scaleLabel: {
            display: true,
            labelString: ['HPE (Horizontal Position Error) (m)']
          },
          ticks: {
            min: 0,
            max: DISPLAY_MAX_X, // 변환된 최대값 사용
            callback: function (value, index, values) {
              // 눈금 레이블을 원래 값으로 표시
              if (value <= BREAK_POINT) {
                return value;
              } else if (value === DISPLAY_MAX_X) {
                return MAX_AXIS_VALUE_X;
              } else {
                const originalValue =
                  BREAK_POINT +
                  ((value - BREAK_POINT) / (DISPLAY_MAX_X - BREAK_POINT)) *
                    (MAX_AXIS_VALUE_X - BREAK_POINT);
                return Math.round(originalValue);
              }
            },
          },
        }],
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: 'HPL (Horizontal Protection Level) (m)'
          },
          ticks: {
            max: MAX_AXIS_VALUE_Y // Set max visible data
          }
        }]
      },
      plugins: {
        stanfordDiagram: {
          epochsLabel: 'Epoch',
          legendLabel: 'Number of epochs per point',
          maxEpochs: 10000,
          countOnlyVisible: false,
          percentage: new Intl.NumberFormat('en-US', {style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 1}),
          regions: [
            {
              points: [
                { x: transformX(0), y: ALERT_LIMIT },
                { x: transformX(MAX_AXIS_VALUE_X), y: ALERT_LIMIT },
              ],
              strokeColor: 'rgba(255, 0, 0, 255)',
              text: {
                x: DISPLAY_MAX_X * 0.4,
                y: ALERT_LIMIT + 10,
                color: 'red',
                format: function () {
                  return 'Alert Limit: ' + ALERT_LIMIT + 'm';
                },
              },
            },
            {
              points: [
                { x: transformX(0), y: 0 },
                { x: transformX(ALERT_LIMIT), y: ALERT_LIMIT },
                { x: transformX(0), y: ALERT_LIMIT },
              ],
              strokeColor: 'rgba(0, 0, 0, 0.5)',
              text: {
                x: DISPLAY_MAX_X / 10,
                y: MAX_AXIS_VALUE_Y / 2,
                color: 'black',
                format: function (value, percentage) {
                  return 'Normal Operations:\n' + value + ' (' + percentage + ')';
                },
              },
            },
            {
              points: [
                { x: transformX(0), y: 0 },
                { x: transformX(ALERT_LIMIT), y: 0 },
                { x: transformX(ALERT_LIMIT), y: ALERT_LIMIT },
              ],
              fillColor: 'rgba(255, 165, 0, 0.2)',
              strokeColor: 'rgba(0, 0, 0, 0.5)',
              text: {
                x: DISPLAY_MAX_X / 4,
                y: MAX_AXIS_VALUE_Y / 8,
                color: 'black',
                format: function (value, percentage) {
                  return `Misleading\nInformation:\n${value} (${percentage})`;
                },
              },
            },
            {
              points: [
                { x: transformX(ALERT_LIMIT), y: 0 },
                { x: DISPLAY_MAX_X, y: 0 },
                { x: DISPLAY_MAX_X, y: ALERT_LIMIT },
                { x: transformX(ALERT_LIMIT), y: ALERT_LIMIT },
              ],
              fillColor: 'rgba(255, 0, 0, 0.2)',
              strokeColor: 'rgba(0, 0, 0, 0.5)',
              text: {
                x: DISPLAY_MAX_X * 0.75,
                y: MAX_AXIS_VALUE_Y / 3,
                color: 'black',
                format: function (value, percentage) {
                  return `HMI:\n${value} (${percentage})`;
                },
              },
            },
            {
              points: [
                { x: transformX(0), y: ALERT_LIMIT },
                { x: transformX(ALERT_LIMIT), y: ALERT_LIMIT },
                { x: DISPLAY_MAX_X, y: MAX_AXIS_VALUE_Y },
                { x: transformX(0), y: MAX_AXIS_VALUE_Y },
              ],
              fillColor: 'rgba(128, 128, 128, 0.2)',
              strokeColor: 'rgba(0, 0, 0, 0.5)',
              text: {
                x: DISPLAY_MAX_X / 10,
                y: (MAX_AXIS_VALUE_Y * 5) / 6,
                color: 'black',
                format: function (value, percentage) {
                  return `System Unavailable Epochs:\n${value} (${percentage})`;
                },
              },
            },
            {
              points: [
                { x: transformX(ALERT_LIMIT), y: ALERT_LIMIT },
                { x: DISPLAY_MAX_X, y: ALERT_LIMIT },
                { x: DISPLAY_MAX_X, y: MAX_AXIS_VALUE_Y },
              ],
              fillColor: 'rgba(255, 165, 0, 0.2)',
              strokeColor: 'rgba(0, 0, 0, 0.5)',
              text: {
                x: transformX(ALERT_LIMIT) + 5,
                y: ALERT_LIMIT + 20,
                color: 'black',
                format: function (value, percentage) {
                  return `Misleading\nInformation:\n${value} (${percentage})`;
                },
              },
            },
          ],
        },
      },
    };

    const plugins = stanfordDiagramPlugin;
    //,plugins: [stanfordDiagramPlugin]
    const chart = new Chart(chartRef.current, {
      type: 'stanford',
      data: data,
      options: options,
      plugins: plugins,
    });

    return () => {
      chart.destroy();
      
    };
//  };
//  fetchData();
  
  }, [chartData]);

  return <canvas ref={chartRef}/>;
  
};